module.exports = {"340722100":"枞阳镇","340722101":"欧山镇","340722102":"汤沟镇","340722103":"老洲镇","340722104":"陈瑶湖镇","340722105":"周潭镇","340722106":"横埠镇","340722107":"项铺镇","340722108":"钱桥镇","340722109":"麒麟镇","340722110":"义津镇","340722111":"浮山镇","340722112":"会宫镇","340722113":"官埠桥镇","340722200":"铁铜乡","340722201":"凤仪乡","340722202":"长沙乡","340722203":"钱铺乡","340722204":"金社乡","340722205":"白梅乡","340722206":"白湖乡","340722207":"雨坛乡","340722400":"枞阳经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340722.json
// module id = 1002
// module chunks = 0